import React from 'react';
import { Copy, Stack } from '@grubhubprod/gh-cookbook-react';

export interface NumberOfItemsInTableProps {
  firstItemNumberFromPage: number;
  lastItemNumberFromPage: number;
  totalResults: number;
  suffix?: string;
}

export const NumberOfItemsInTable: React.FC<NumberOfItemsInTableProps> = ({
  firstItemNumberFromPage,
  lastItemNumberFromPage,
  totalResults,
  suffix = '',
}) => {
  const range = `${firstItemNumberFromPage} - ${lastItemNumberFromPage}`;
  const displayTextRange = `${range} of ${totalResults}`;
  const displayText = `${displayTextRange} ${suffix}`;

  return (
    <Stack y="x-sm">
      <Copy variant="body" color="secondaryText">
        {displayText}
      </Copy>
    </Stack>
  );
};
